"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AntdIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _icons = _interopRequireDefault(require("@ant-design/icons"));

const AntdIcon = props => {
  const {
    fontAwesomeIcon,
    size,
    classes,
    title
  } = props;

  const FaIcon = icon => {
    return () => /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      size: size,
      icon: icon,
      className: classes
    });
  };

  return /*#__PURE__*/_react.default.createElement(_icons.default, {
    title: title,
    component: FaIcon(fontAwesomeIcon)
  });
};

exports.AntdIcon = AntdIcon;
var _default = AntdIcon;
exports.default = _default;